import { l } from '@manychat/manyui'

import { getAiStepHeader } from 'common/builder/components/chart/FlowChart/adapters/generic/nodes/converterRules/helpers/getAiStepHeader'
import { AI_AGENT_DESCRIPTION_MAX_LENGTH } from 'common/builder/components/chart/FlowChart/constants'
import { FlowChartContentNodeBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartContentNodeBuilder'
import { FlowChartContentRespontentsBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartContentRespontentsBuilder'
import { FlowChartEmptyNodeBlockBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartEmptyNodeBlockBuilder'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import { FlowChartTextBlockBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartTextBlockBuilder'
import {
  ConverterRule,
  NodeConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { getContentNodeStatTable } from 'common/builder/components/chart/FlowChart/lib/utils/getContentNodeStatTable'
import { AiAgentConfig } from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import { FlowChartBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { FlowChartContentNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartContentNode'
import { NodeType } from 'common/builder/constants/NodeType'
import { getNodeCtrUniqueUsers } from 'common/builder/models/Button/typedHelpers'
import { AiAgentNodeType } from 'common/builder/nodes/nodeInterfaces'

export const AiStepNodeGenericConverterRule: ConverterRule<
  AiAgentNodeType,
  FlowChartContentNode,
  NodeConverterRulePayload
> = {
  predicate: (entity: AiAgentNodeType) => entity?.nodeType === NodeType.AI_AGENT,

  convert: function (
    entity: AiAgentNodeType,
    { rootNodeId, isStatByJSONAdsTrigger },
  ): FlowChartContentNode | null {
    const isRootWithJSONAds = rootNodeId === entity.id && isStatByJSONAdsTrigger

    const respondentsCount = entity.stats?.sentUnique || 0

    const nextStep = new FlowChartNextStepBuilder(entity.id)
      .withLabel(l.translate('Next Step'))
      .build()

    let agentText = ''

    if (entity.agent_data) {
      const shortLabel = entity.agent_data.config.goal.slice(0, AI_AGENT_DESCRIPTION_MAX_LENGTH)

      agentText =
        entity.agent_data.config.goal.length > shortLabel.length ? `${shortLabel}…` : shortLabel
    }

    let contentBlock: FlowChartBlock = new FlowChartEmptyNodeBlockBuilder()
      .withText(l.getString(AiAgentConfig.placeholderText))
      .build()

    if (entity.agent_data) {
      contentBlock = new FlowChartTextBlockBuilder(`agent_description_${entity.id}`)
        .withText(agentText)
        .build()
    }

    return new FlowChartContentNodeBuilder(entity.id)
      .withNodeType(NodeType.AI_AGENT)
      .withHeader(getAiStepHeader(entity))
      .withDeliveredUniqueUsers(getNodeCtrUniqueUsers(entity))
      .withStatsTable(getContentNodeStatTable(entity, { isRootWithJSONAds }))
      .withRespondents(
        respondentsCount
          ? new FlowChartContentRespontentsBuilder(respondentsCount)
              .withContentId(entity.contentId)
              .build()
          : null,
      )
      .withBlocks([contentBlock])
      .withNextSteps([nextStep])
      .build()
  },
}
